import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useEnableModel() {
  const queryClient = useQueryClient()

  const action = async (id) => {
    const response = await httpClient.post(`team/models/${id}/enable`)
    return response.data
  }

  return useMutation({
    mutationFn: action,
    onSuccess: (e) => {
      queryClient.invalidateQueries({
        queryKey: ['models'],
      })

      queryClient.invalidateQueries({
        queryKey: ['transactions'],
      })

      toast.success(e?.response?.data?.message ?? 'Changes saved successfully')
    },
    onError: (e) => {
      toast.error(
        e?.response?.data?.message ?? 'Something went wrong. Please try again.',
      )
    },
  })
}
